import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { hqApi } from "@/hq/hqApi";

const HQAuthContext = createContext(null);

export function HQAuthProvider({ children }) {
  // null = checking, false = not authed, object = admin
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    hqApi
      .get("/auth/me")
      .then((r) => setAdmin(r.data))
      .catch(() => setAdmin(false));
  }, []);

  const login = useCallback(async (email, password) => {
    // Cookie is set HttpOnly by the server on this response.
    const { data } = await hqApi.post("/auth/login", { email, password });
    setAdmin(data.admin);
    return data.admin;
  }, []);

  const logout = useCallback(async () => {
    try { await hqApi.post("/auth/logout"); } catch { /* no-op */ }
    setAdmin(false);
  }, []);

  return (
    <HQAuthContext.Provider value={{ admin, login, logout }}>
      {children}
    </HQAuthContext.Provider>
  );
}

export function useHQAuth() {
  const ctx = useContext(HQAuthContext);
  if (!ctx) throw new Error("useHQAuth must be used inside HQAuthProvider");
  return ctx;
}
